export default "__VITE_ASSET__DrTUzvXV__"